import { Pipe, PipeTransform } from '@angular/core';
import { AreaTextPipe } from '@bo-client/shared/pipes/area-text.pipe';
import { OrderDto } from '@bo-client/shared/models/orderDto';

@Pipe({
  name: 'contacNamePipe'
})
export class ContactNamePipe implements PipeTransform {
  transform(orderList: OrderDto[], selectedName?: string | null) {
    const areaTextPipe = new AreaTextPipe();
    const nameList: string[] = [];
    if (orderList == null) {
      return nameList;
    }
    if (selectedName == null) {
      orderList.forEach((xName) => {
        nameList.push(xName.contactName);
      });
      return nameList;
    }
    if (selectedName == '') {
      orderList.forEach((xName) => {
        if (xName.contactName) {
          if (xName.contactName != '') {
            nameList.push(areaTextPipe.transform(xName.area) + ' / ' + xName.contactName);
          }
        }
      });
      return nameList;
    }
    const numItems = orderList.length;
    if (numItems == 0) {
      return nameList;
    }
    const idxList = orderList.findIndex((x) => x.contactName == selectedName);
    if (idxList == -1) {
      return nameList;
    } else {
      nameList.push(areaTextPipe.transform(orderList[idxList].area) + ' / ' + orderList[idxList].contactName);
      return nameList;
    }
  }
}
